module.exports = __webpack_public_path__ + "static/adineuePRO-BoldWeb-115c51c3f475cb05f7c7d0fecc1c687b.woff";